import { render, staticRenderFns } from "./DesignPopupDisplayUrlManage.vue?vue&type=template&id=2e5f21ea&"
import script from "./DesignPopupDisplayUrlManage.vue?vue&type=script&lang=ts&"
export * from "./DesignPopupDisplayUrlManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports